import {
  UPDATE_CART, 
  UPDATE_CARTSHOPPING,
  GET_PRODUCT_LIST,
  ADD_PRODUCT,
  UPDATE_PRODUCT,
  DELETE_PRODUCT,
  CLEAR_ALL_PRODUCT,
  SETTLE,
  ADD_SECKILL_COUNT,
  REDUCE_SECKILL_COUNT,
  UPDATE_SECKILL_COUNT,
  UPDATE_NEWCARTSHOPPING,
  ADD_DROPSHIPPING_PRODUCT,
  DELETE_DROPSHIPPING_PRODUCT,
  CLEAR_ALL_DROPSHIPPING_PRODUCT,
  SETTLE_DROPSHIPPING_PRODUCT,
  ADD_DROPSHIPPING_COUNT,
  REDUCE_DROPSHIPPING_COUNT,
  UPDATE_DROPSHIPPING_COUNT
} from "./mutation-type.js";

const name = "cart";

const state = {
   //右侧浮窗购物车子数据弹窗开关
  carDialogVisible: false,
  //右侧浮窗弹窗子数据
  ChildProductInfo: [],
  dataList: [], // 购物车列表数据
  cartLists: [],
  seckillCount: localStorage.getItem('seckillCount') || 0,
  dropShippingCount: localStorage.getItem('dropShippingCount') || 0,
  newPolicyProduct: [],
};

const getters = {
  cartCount(state) {
      let count = 0;
      state.dataList.forEach(data => {
          count = count + data.ProductList.length;
      });
      return count;
  },
  newCartCount(state){
    let count = 0;
    state.newPolicyProduct.forEach(data => {
        count = count + data.ProductList.length;
    });
    return count;
  }
};

const actions = {

  toggleCarDialog({
    commit
  }, flag) {
    commit('toggleCarDialog', flag);
  },
  initChildProductInfo({
    commit
  }, data) {
    data = data || [];
    commit('initChildProductInfo', data);
  },

  async [GET_PRODUCT_LIST]({
    commit
  }) {
    let url = "api/ShoppingCart/GetProductList";
    let res = await rt.get(url);
    let dataList = res.map(item => {
      item.currentIndex = -1;
      item.ProductList.forEach(product => {
        product.checked = false;
      });
      return item;
    });
    commit(UPDATE_CART, dataList);
  },
  async [ADD_PRODUCT]({
    dispatch
  }, product) {
    let url = "api/ShoppingCart/AddProductList";
    await rt.post(url, product);
  },
  
  async [UPDATE_PRODUCT]() {},
  async [DELETE_PRODUCT]({ dispatch }, id) {
      let url = "api/ShoppingCart/DeleteProduct?id=" + id;
      await rt.post(url);

      dispatch(GET_PRODUCT_LIST);
  },
  async [CLEAR_ALL_PRODUCT]({ dispatch }) {
      let url = "api/ShoppingCart/ClearAllProduct";
      await rt.post(url);

      dispatch(GET_PRODUCT_LIST);
  },
  async [SETTLE]({ dispatch }, data) {
      let url = "api/ShoppingCart/Settle";
      var id = await rt.post(url, data);

      dispatch(GET_PRODUCT_LIST);

      return id;
  },

  // CP from PRODUCT
  async [ADD_DROPSHIPPING_PRODUCT]({
    dispatch
  }, product) {
    let url = "api/ShoppingCart/AddProductList";
    return await rt.post(url, product);
  },

  async [DELETE_DROPSHIPPING_PRODUCT]({ dispatch }, id) {
      let url = "api/ShoppingCart/DeleteProduct?id=" + id;
      await rt.post(url);

      dispatch(GET_PRODUCT_LIST);
  },
  async [CLEAR_ALL_DROPSHIPPING_PRODUCT]({ dispatch }) {
      let url = "api/ShoppingCart/ClearAllProduct";
      await rt.post(url);

      dispatch(GET_PRODUCT_LIST);
  },
  async [SETTLE_DROPSHIPPING_PRODUCT]({ dispatch }, data) {
      let url = "api/ShoppingCart/Settle";
      var id = await rt.post(url, data);

      dispatch(GET_PRODUCT_LIST);

      return id;
  }
};

const mutations = {

  toggleCarDialog(state, flag) {
    state.carDialogVisible = flag;
  },
  initChildProductInfo(state, data) {
    state.ChildProductInfo = data;
  },

  [UPDATE_CART](state, dataList) {
      state.dataList = dataList;
  }, 
  [UPDATE_CARTSHOPPING](state, dataList) {
      state.cartLists = dataList;
  },
   //新政策产品赋值
   [UPDATE_NEWCARTSHOPPING](state, dataList) {
    state.newPolicyProduct = dataList;
   },
  // 增加一个产品到秒杀清单
  [ADD_SECKILL_COUNT](state) {
    state.seckillCount++;
    localStorage.setItem('seckillCount', state.seckillCount);
  },
  // 减少一个产品到秒杀清单
  [REDUCE_SECKILL_COUNT](state) {
    if (state.seckillCount <= 0) return;
    state.seckillCount--;
    localStorage.setItem('seckillCount', state.seckillCount);
  },
  // 更新秒杀清单的数量
  [UPDATE_SECKILL_COUNT](state, count) {
    state.seckillCount = count;
    localStorage.setItem('seckillCount', state.seckillCount);
  },
  // 增加一个产品到代发清单（购物车）
  [ADD_DROPSHIPPING_COUNT](state) {
    state.dropShippingCount++;
    localStorage.setItem('dropShippingCount', state.dropShippingCount);
  },
  // 减少一个产品到代发清单（购物车）
  [REDUCE_DROPSHIPPING_COUNT](state) {
    if (state.dropShippingCount <= 0) return;
    state.dropShippingCount--;
    localStorage.setItem('dropShippingCount', state.dropShippingCount);
  },
  // 更新代发清单的数量（购物车）
  [UPDATE_DROPSHIPPING_COUNT](state, count) {
    state.dropShippingCount = count;
    localStorage.setItem('dropShippingCount', state.dropShippingCount);
  }
}; 


export default {
  name,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/cart/index.js